import React, { useContext, useEffect } from 'react';
import { CognitoOTPAuthContext } from 'cognito/CognitoOTPAuthContext';

const SessionExpiry = () => {

  const { logout } = useContext(CognitoOTPAuthContext);

  useEffect(() => {
    logout()
  }, [])

  return <></>;
};

export default SessionExpiry;
